import React, { Component, createElement, Fragment } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { get } from 'lodash';

import { errorHandle } from '../../services';

const api = services.api;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface IState {
    selectedKeys: any;
}

class blackListTable extends Component<CategoryFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
        };
        // this.onAdd = this.onAdd.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
    }

    // onAdd(attr_code: string, attr_value_codes: string[]) {
    //     const { params, entity } = this.props;
    //     if (!params || !params.categoryId) return;

    //     api.post(
    //         { attr_code, attr_value_codes },
    //         { apiPath: `/display_category/${params.categoryId}/filter_attr` }
    //     ).then(() => {

    //         // 列表数据刷新
    //         entity.search({
    //             ...entity.params,
    //             ...entity.filters,
    //         });
    //     })
    //     .catch(errorHandle);
    // }

    onDeleteBatch() {
        const { entity, params } = this.props;
        const { selectedKeys } = this.state;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            let copyselect = selectedKeys.join(',');
            entity.delete(
                {
                    ids: copyselect,
                    type: 'batch',
                },
                {
                    action: actions.searchAction(entity, { ...params }),
                }
            );
        }
    }

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;

        const params = {
            page,
            perPage,
            ...filters,
        };
        api.get(params, { apiPath: `/products/skuBlackList/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    renderControllers() {
        const layoutProps = {
            component: 'GridLayout',
            items: [
                {
                    component: 'UploadButton',
                    span: 3,
                    buttons: {
                        text: '导入黑名单',
                        type: 'primary',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.xls,.xlsx,.csv',
                    action: '/templates/ADD_BLACK_LIST',
                    className: 'upload-button',
                },
                {
                    component: 'Button',
                    text: '导出黑名单',
                    type: 'primary',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteAll,
                },
                {
                    component: 'Button',
                    text: '从黑名单移出',
                    type: 'primary',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteBatch,
                },
                {
                    component: 'ExportButton',
                    text: '下载模板',
                    type: 'default',
                    source: {
                        apiPath: '/templates/IMPORT_SKU_BLACK_LIST',
                    },
                    span: 3,
                    style: { marginBottom: '20px' },
                },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            rowKey: 'id',
            componentId: componentId + '-Table',
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[]) => {
                    this.setState({
                        selectedKeys,
                    });
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'skuCode',
                },
                {
                    property: 'name',
                },
                {
                    property: 'salePrice',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        text: '从黑名单移出',
                        type: 'delete',
                        config: {
                            type: 'link',
                            tooltip: null,
                            title: '是否确认移出黑名单？',
                            okText: '确定',
                            cancelText: '取消',
                        },
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        return (
            <Fragment>
                {this.renderControllers()}
                {this.renderTable()}
            </Fragment>
        );
    }
}

// function mapStateTopProps(state: any, props: any) {
//     const { componentId } = props;
//     const component = state.components[componentId];
//     const componentState = {
//         selectedRowKeys: get(component, 'selectedRowKeys'),
//     };
//     return componentState;
// }

export const BlackListTable = connect()(blackListTable);
